//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Report.js";
import "../no/NXObject.js";
let d=[[[0,"ReportCollection",0,"Report.IReportCollection",0],[0,"TemplateFile",1,0]],[[["templateItemsCount","pTemplateItems"],"GetTemplateItems",{},0,0],[["inputType"],"CreateUserItem",{R_:{userItem:"Report.IUserItem"}},1,0],[["userItem"],"CopyUserItem",{R_:{userItemCopied:"Report.IUserItem"}},1,0],[["userItemsCount","userItems"],"GetUserItems",{},0,0],[["userItems","newLocation","referencedItem"],"MoveUserItems",{},3,0],[["reportDocument","listError"],"Export",{},2,0],[[],"ClearTemplateItems",{},0,0],[[],"DeleteUserItems",{},0,0],[["hideTemplateItemsWithoutInput"],"HideTempalteItemsWithoutInput",{},1,0],[[],"SynchronizeWithCommands",{},0,0]],[]];
SPLM.Report.Report = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Report.Report";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Report.Report.MoveItemLocation = Object.freeze({
    "Before" : "Before", "After" : "After"});

export default SPLM;